export default __webpack_public_path__ + "static/media/afan_azmi.12c5a28f.jpg";